import { FC, useEffect } from 'react';
import { init } from '@fullstory/browser';

export const FullstoryProvider: FC<{ env: string }> = ({ env }) => {
  const isActive = !['functional-testing', 'development'].includes(env);

  useEffect(() => {
    if (isActive) {
      // Scoped to actual embeds — most of consumer-app is never embedded
      // (only the guest buyflow is), and there's no reason to isolate a
      // session that has no parent to isolate from.
      const isIFramed = window.self !== window.top;
      init({
        orgId: 'stw',
        ...(isIFramed ? { recordOnlyThisIFrame: true } : {}),
      });
    }
  }, [isActive]);

  return null;
};
